import { DeadlineItem, Evidence } from "../../../../types";
import { ZeitstrahlPunkt } from "../../../common/display/Zeitstrahl";
import { openManualDeadlines } from "../../../../utils/deadlines";

/**
 * Die offenen Termine der Nachweise als Punkte für den Zeitstrahl – je Nachweis die Frist seines
 * Status und jeder offene manuelle Termin (ADR 010). Alle Punkte eines Nachweises wählen ihn aus.
 * Archivierte Nachweise und erledigte Termine fehlen.
 */
export const zeitstrahlPunkte = (
  evidences: Evidence[],
  deadlines: DeadlineItem[] = [],
): ZeitstrahlPunkt[] =>
  evidences.flatMap((evidence) => {
    if (evidence.archiviert) return [];
    const title = evidence.bezeichnung || evidence.evidence_type.name;
    const frist = evidence.offene_frist;
    const fristPunkt: ZeitstrahlPunkt[] = frist
      ? [
          {
            id: `${evidence.id}:frist`,
            selectionId: evidence.id,
            datum: frist.zieltermin,
            titel: title,
            untertitel: frist.anlass,
            notiz: evidence.note,
          },
        ]
      : [];
    const manuellePunkte = openManualDeadlines(deadlines, evidence.id).map(
      (deadline): ZeitstrahlPunkt => ({
        id: deadline.id,
        selectionId: evidence.id,
        datum: deadline.zieltermin as string,
        titel: title,
        untertitel: deadline.bezeichnung,
        notiz: deadline.note ?? evidence.note,
      }),
    );
    return [...fristPunkt, ...manuellePunkte];
  });
